'use client'

import { useTranslations } from 'next-intl'

interface CouponInputProps {
  baseTotal: number;
  locale: string;
  couponCode: string;
  onCouponCodeChange: (code: string) => void;
  onApply: () => void;
  isLoading: boolean;
  error: string | null;
  isApplied: boolean;
}

export function CouponInput({
  couponCode,
  onCouponCodeChange,
  onApply,
  isLoading,
  error,
  isApplied
}: CouponInputProps) {
  const t = useTranslations('checkout.coupon') // Assuming 'checkout.coupon' path in your translation files

  return (
    <div className="bg-surface rounded-xl backdrop-blur-sm">
      <div className="p-6 flex items-center justify-between">
        <h2 className="text-2xl font-semibold text-primary flex items-center">
          {t('title')}
        </h2>
        {isApplied && <span className="text-status-success text-sm">{t('applied')}</span>}
      </div>
      <div className="p-6 pt-0">
        <div className="space-y-4">
          <div>
            <div className="mt-1 flex rounded-md shadow-sm focus-within:ring-2 focus-within:ring-primary">
              <input
                type="text"
                name="coupon-code"
                id="coupon-code"
                value={couponCode}
                onChange={(e) => onCouponCodeChange(e.target.value)}
                disabled={isApplied}
                className="shadow-sm block w-full sm:text-sm bg-surface-hover rounded-l-md p-2 text-text-main focus:outline-none border-r-0"
                placeholder={t('inputPlaceholder')}
              />
              <button
                type="button"
                onClick={onApply}
                disabled={isLoading || isApplied}
                className={`inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-r-md text-white bg-primary hover:bg-primary-light focus:outline-none focus:ring-2 focus:ring-offset-0 focus:ring-primary-light transition-colors ${isLoading || isApplied ? 'opacity-50 cursor-not-allowed' : ''}`}
              >
                {isLoading ? t('applying') : t('applyButton')}
              </button>
            </div>
            {error && <p className="mt-1 text-xs text-status-error">{error}</p>}
          </div>
        </div>
      </div>
    </div>
  )
} 